import { render, staticRenderFns } from "./Prev.vue?vue&type=template&id=5237ec86&"
import script from "./Prev.vue?vue&type=script&lang=js&"
export * from "./Prev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports